import React, {useCallback, useEffect, useRef} from 'react';
import {AccessibilityInfo, findNodeHandle, Image, View} from 'react-native';

// import OptaviaConnectLogo from '/asset/image/connect_logo_vertical.png';
import OptaviaConnectLogo from '/asset/image/connect_logo.png';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {Login} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {useHeader} from './Header.hook';
import {styles} from './Header.style';
interface HeaderProps {
  isKeyboardShown: boolean;
  showMaintenanceBanner: boolean;
}

const Header: React.FC<HeaderProps> = ({
  isKeyboardShown = false,
  showMaintenanceBanner = false,
}) => {
  const {gutterStyle, onLayout} = useHeader();
  const logoRef = useRef<View>(null);
  const logoFocusTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hasAnnouncedLogoRef = useRef(false);

  const focusLogoForScreenReader = useCallback(() => {
    // Ensure screen readers land on the logo first
    if (logoFocusTimeout.current) {
      clearTimeout(logoFocusTimeout.current);
    }

    AccessibilityInfo.isScreenReaderEnabled().then(isEnabled => {
      if (
        !isEnabled ||
        !logoRef.current ||
        typeof AccessibilityInfo.setAccessibilityFocus !== 'function' ||
        hasAnnouncedLogoRef.current
      ) {
        return;
      }

      const handle = findNodeHandle(logoRef.current);
      if (!handle) {
        return;
      }

      logoFocusTimeout.current = setTimeout(() => {
        AccessibilityInfo.setAccessibilityFocus(handle);
        hasAnnouncedLogoRef.current = true;
      }, 150);
    });
  }, []);

  // TODO will check
  /*   const handleLogoLayout = useCallback(
    event => {
      onLayout(event);
      focusLogoForScreenReader();
    },
    [focusLogoForScreenReader, onLayout],
  ); */

  useEffect(() => {
    const delay = setTimeout(() => {
      focusLogoForScreenReader();
    }, 200);

    return () => {
      clearTimeout(delay);
      if (logoFocusTimeout.current) {
        clearTimeout(logoFocusTimeout.current);
        logoFocusTimeout.current = null;
      }
    };
  }, [focusLogoForScreenReader]);
  let logoStyle = [styles.maintenanceLogoStyle];
  if (!isKeyboardShown && showMaintenanceBanner) {
    // @ts-expect-error TS(2345): Argument of type '{ width: "100%"; height: number;... Remove this comment to see the full error message
    logoStyle.push(styles.bannerStyle);
  }

  return (
    <>
      <View
        ref={logoRef}
        accessible
        importantForAccessibility="yes"
        accessibilityLabel="Optavia Coach"
        style={styles.logoContainer}
        {...testProperties(Login.loginLogo)}>
        <Image
          style={styles.logoIcon}
          source={OptaviaConnectLogo}
          resizeMode="contain"
          onLayout={onLayout}
          accessibilityElementsHidden={true}
          importantForAccessibility="no"
        />
        <Text
          style={styles.optaviaText}
          accessibilityElementsHidden={true}
          importantForAccessibility="no">
          <Text style={styles.optaviaBold} isBold>
            OPTA
          </Text>
          <Text style={styles.optaviaRegular}>VIA</Text>
          <Text style={styles.registered}>®</Text>
        </Text>

        <Text
          style={styles.coachText}
          accessibilityElementsHidden={true}
          importantForAccessibility="no">
          COACH
        </Text>
      </View>
      <Gutter style={gutterStyle} />
    </>
  );
};

export {Header};
